import { Game } from "./game"

export const speedsMap: Record<Game, number[]> = {
  [Game.MK8]: [150],
  [Game.MK8DX]: [150, 200],
}
